import { getThicknessEditorStringValue } from 'components/property-editors/editors/EditorStringValueUtils';
import React from 'react';
import { IEditorProps } from './Editor';
import { GridPopupEditor } from './GridPopupEditor';
// import './ThicknessEditor.less'

interface IThicknessEditorProps extends IEditorProps {}

/**
 * A popup editor with specific logic for rendering thickness summary.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ThicknessEditor(props: IThicknessEditorProps) {
  return <GridPopupEditor {...props}>{getThicknessEditorStringValue(props.child)}</GridPopupEditor>;
}
